// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__jjea3","question":"Question_question__1K5cS","description":"Question_description__3NMW1"};